import { BASE_MONEY_FORMAT } from '../../../constants'
import { formatDateOrNull, MaybeStringOrNumber } from '../../../utils'
import { DenseTableRowProps, CellProps } from '../types'

export const getTxt = <RowDataType>(
  cellValue: unknown,
  cellProps: CellProps<RowDataType>
): MaybeStringOrNumber => {
  if (cellValue == null) {
    return cellProps.displayWhenNull || ''
  } else if (cellProps.dateFormat && Date.parse(cellValue as string) > 1) {
    return formatDateOrNull(cellValue as string, cellProps.dateFormat)
  } else if (cellProps?.money) {
    const formattedMoney = BASE_MONEY_FORMAT.format(cellValue as number)
    return formattedMoney
  } else {
    return cellValue as MaybeStringOrNumber
  }
}

// Filter away columns where hideColumn is set to true or
// hideIfNoValues is set to true and no values are found in any of the objects
export const filterColumns = <RowDataType>(
  data: DenseTableRowProps<RowDataType>[],
  recipe: CellProps<RowDataType>[]
) => {
  const filtered = recipe.filter(
    (cellProps: CellProps<RowDataType>) =>
      cellProps.hideColumn !== true &&
      (cellProps.hideIfNoValues !== true ||
        data.some(
          (rowProps: DenseTableRowProps<RowDataType>) =>
            rowProps[cellProps.key] != null
        ))
  )

  return filtered
}
